import React from 'react';
import { Provider } from 'mobx-react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';
import moment from 'moment';
import localization from 'moment/locale/id';

import Layout from './core/components/Layout';
import ErrorBoundary from './core/components/ErrorBoundary';
import ErrorView from './core/components/ErrorView';
import AppSnackBar from './core/components/AppSnackBar';

import stores from './core/stores';

import Routes from './AppRoute';

import 'bootstrap/dist/css/bootstrap.css';
import '../styles/styles.scss';

const renderRoutes = () => Routes.map((route, index) => <Route key={index} {...route} />);

function App() {
  moment.updateLocale('id', localization);
  return (
    <ErrorBoundary render={() => <ErrorView />}>
      <Provider {...stores}>
        <HelmetProvider>
          <AppSnackBar />
          <BrowserRouter>
            <Layout>
              <Switch>{renderRoutes()}</Switch>
            </Layout>
          </BrowserRouter>
        </HelmetProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
